import { collections } from "@/mocks/collections";

export default function CollectionList() {
  return (
    <section id="collections" className="w-full border-b border-background-200/70 bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-widest text-primary-600">合集 · 大全 · 汇总</span>
            <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              一份一份整理好的名单，拿来就用
            </h2>
          </div>
          <p className="max-w-md text-xs leading-5 text-foreground-600">
            合集讲主题，大全讲范围，汇总讲顺序。每份名单都写清了入口数量和最近更新时间，更新慢的会直接标出来。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 lg:grid-cols-2">
          {collections.map((item) => (
            <a
              key={item.id}
              href="#collections"
              className="flex cursor-pointer flex-col gap-3 rounded-md border border-background-200 bg-background-50 p-4 transition-colors hover:border-accent-300 hover:bg-accent-50 md:p-5"
            >
              <div className="flex items-start justify-between gap-3">
                <h3 className="font-heading text-base font-bold text-foreground-950">{item.name}</h3>
                <span className="flex shrink-0 items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] text-secondary-900">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-links-line text-xs" />
                  </span>
                  {item.entries}
                </span>
              </div>
              <p className="text-sm leading-6 text-foreground-700">{item.desc}</p>
              <div className="flex flex-wrap items-center justify-between gap-2 border-t border-background-200/70 pt-3">
                <span className="flex flex-wrap items-center gap-1.5">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full border border-background-300/70 px-2 py-0.5 text-[11px] text-foreground-600"
                    >
                      {tag}
                    </span>
                  ))}
                </span>
                <span className="flex items-center gap-2 text-[11px] text-foreground-500">
                  {item.updated}
                  <span className="flex h-4 w-4 items-center justify-center text-primary-500">
                    <i className="ri-arrow-right-up-line text-sm" />
                  </span>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}